// extracted by mini-css-extract-plugin
export default {"DaysList":"OfferScheduleCustom_DaysList__uAz5d"};